module.exports = __webpack_public_path__ + "static/screen-training-ed4df49367b8a06cb23b7dca82feae70.png";